import { render, staticRenderFns } from "./StyleColor.vue?vue&type=template&id=0218020c&"
import script from "./StyleColor.vue?vue&type=script&lang=js&"
export * from "./StyleColor.vue?vue&type=script&lang=js&"
import style0 from "./StyleColor.vue?vue&type=style&index=0&id=0218020c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports